import {ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {DepotYard} from "../../../shared/view-model/store-management/depot-yard.type";
import {FormBuilder, FormControl} from "@angular/forms";
import {DepotService} from "../../services/depot-service/depot.service";
import {ApolloQueryObservable} from "apollo-angular";
import {appInjector} from "../../../index";
import {Subscription} from "rxjs/Subscription";
import {Observable} from "rxjs/Observable";

export const ERR_DEPOT_YARD_DOES_NOT_EXIST = 'ERR_DEPOT_YARD_DOES_NOT_EXIST';

export const DEPOT_YARD_ERRORS = {
  ERR_DEPOT_YARD_DOES_NOT_EXIST: 'Der Lagerplatz ist in dem derzeit ausgewählten Lager nicht vorhanden! Bitte wählen Sie einen anderen Lagerplatz aus.'
};

@Component({
  selector: 'vb-depot-yard-selection',
  templateUrl: './depot-yard-selection.component.html',
  styleUrls: ['./depot-yard-selection.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => DepotYardSelectionComponent)}]
})
export class DepotYardSelectionComponent extends AbstractVisbosControl<DepotYard, FormControl> implements OnInit, OnDestroy {

  private depotYards$: ApolloQueryObservable<DepotYard[]>;
  depotYards: DepotYard[];
  private depotYardsSub: Subscription;

  private _depotId: string | Observable<string>;

  @Input()
  set depotId(value: string | Observable<string>) {

    this._depotId = value;

    this.depotYards$ = this.depotService.getDepotYards(value);

    this.depotYardsSub = this.depotYards$.subscribe((dY: any) => {
      this.depotYards = dY;

      if (this.control.value) {
        if (!this.depotYards.find(yard => yard.cuid == this.control.value)) {
          this.control.setErrors({ERR_DEPOT_YARD_DOES_NOT_EXIST: true});
        } else {
          this.control.setErrors({ERR_DEPOT_YARD_DOES_NOT_EXIST: false});
          this.control.updateValueAndValidity();
        }
      }

    });

  }


  ngAfterViewInit(): any {
    super.ngAfterViewInit();
  }

  @Output()
  depotYardSelected: EventEmitter<DepotYard> = new EventEmitter();

  get depotId(): string | Observable<string> {
    return this._depotId;
  }

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, private depotService: DepotService) {
    super(fb, cd, null);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    this.depotYardsSub.unsubscribe();
  }

  buildControlContent(values?: DepotYard): FormControl {
    return DepotYardSelectionComponent.initControl(this.fb, values);
  }

  public static initControl(fb: FormBuilder = null, value?: DepotYard): FormControl {
    fb = fb ? fb : appInjector().get(FormBuilder);
    return fb.control(null);
  }

  public setDefaultValues(item?: DepotYard): { [controlKey: string]: any } | any {
    return this.setValue(item, 'cuid');
  }

  onDepotYardSelected(item: DepotYard) {
    this.depotYardSelected.emit(item);
  }

  onDepotDeselected(event?) {
    console.info("Depot yard unselected");
    this.depotYardSelected.emit(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/depot/depot-yard-selection/depot-yard-selection.component.ts